export enum actions {
    testFen = "testFen",
    findProblem = "findProblem"
  }
  